
interface SoldFiltersProps {
  makes: string[];
  bodyTypes: string[];
  selectedMake: string;
  selectedBodyType: string;
  sortBy: string;
  onMakeChange: (val: string) => void;
  onBodyTypeChange: (val: string) => void;
  onSortChange: (val: string) => void;
  resultCount: number;
}

export default function SoldFilters({
  makes,
  bodyTypes,
  selectedMake,
  selectedBodyType,
  sortBy,
  onMakeChange,
  onBodyTypeChange,
  onSortChange,
  resultCount,
}: SoldFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div className="flex flex-wrap items-center gap-3">
        <select
          value={selectedMake}
          onChange={(e) => onMakeChange(e.target.value)}
          className="px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
        >
          <option value="">All Makes</option>
          {makes.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>

        <select
          value={selectedBodyType}
          onChange={(e) => onBodyTypeChange(e.target.value)}
          className="px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
        >
          <option value="">All Body Types</option>
          {bodyTypes.map((b) => (
            <option key={b} value={b}>{b}</option>
          ))}
        </select>

        <span className="text-sm text-gray-500 ml-1">
          {resultCount} vehicle{resultCount !== 1 ? 's' : ''}
        </span>
      </div>

      <select
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value)}
        className="px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
      >
        <option value="recent">Most Recent</option>
        <option value="price-high">Price: High to Low</option>
        <option value="price-low">Price: Low to High</option>
        <option value="fastest">Fastest Sale</option>
      </select>
    </div>
  );
}
